import './ForumCommets.less';

import React, { useContext } from 'react';

import i18n from '@i18n';
import MdForumContext from '@/markdown/modules/MdForumContext';
import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';

const LoadableEditorWithComments = Loadable({
    loader: imports.betbook,
    exp: Exp => Exp.EditorWithComments
});

function ForumComments() {
    const { subjectId, subjectType } = useContext(MdForumContext);
    if (!subjectId || !subjectType) {
        return null;
    }

    return (
        <LoadableEditorWithComments
            className="forum-comments"
            subjectId={subjectId}
            subjectType={subjectType}
            title={i18n('chat.type.chat')}
        />
    );
}

export default ForumComments;
